// extracted by mini-css-extract-plugin
export default {"appleform":"SuspendedLanding_appleform__0Pftz","confirmBold":"SuspendedLanding_confirmBold__Fp0O4"};